export const getDeviceName = (): string => {
  // Αν ο browser υποστηρίζει το σύγχρονο API
  const nav: any = navigator;
  if (nav.userAgentData?.platform) {
    return `OS: ${nav.userAgentData.platform}`;
  }

  // Fallback με βάση το userAgent string
  const ua = navigator.userAgent;
  if (ua.includes("Win")) return "Windows PC";
  if (ua.includes("Mac")) return "Macintosh";
  if (ua.includes("Linux")) return "Linux PC";
  if (ua.includes("Android")) return "Android Device";
  if (ua.includes("like Mac") || ua.includes("iPhone")) return "iOS Device";

  return navigator.platform || "Web Browser";
};
